import { cn } from "@/lib/utils";

/**
 * A product's sell unit ("case", "each", "lb") as a small pill after its name.
 * Renders nothing for a product without one, so a catalogue with no units looks
 * exactly as it did before units existed.
 */
export function UnitPill({ unit, className }: { unit?: string | null; className?: string }) {
  if (!unit) return null;
  return (
    <span
      className={cn(
        "ml-1.5 inline-flex items-center whitespace-nowrap rounded-full bg-gray-100 px-2 py-0.5 align-middle text-xs font-semibold leading-none text-gray-600",
        className,
      )}
      data-testid="unit-pill"
    >
      {unit}
    </span>
  );
}
